module.exports = __webpack_public_path__ + "img/1-sm.df312a2c.jpg";